/* eslint-disable no-sparse-arrays */
import { splitCamelCase } from '../../utils';
const convertToCssCustomProperty = color => {
  const paramCaseColor = splitCamelCase(color).replace(new RegExp(' ', 'g'), '-').toLocaleLowerCase();
  if (!color.includes('color')) {
    return `var(--color-${paramCaseColor})`;
  }
  return `var(--${paramCaseColor})`;
};

/**
 * @param {string} color - name of the color from the tokenset, the color must start with 'color')
 * @returns - [undefined, style]
 *
 * @example
 * const [, colorStyle] getColor('colorPrimaryBase');
 */
const getColor = color => {
  if (!color) {
    return [undefined, undefined];
  }
  return [undefined, convertToCssCustomProperty(color)];
};

/**
 * @param {string} color - name of the color from the tokenset, the color must start with 'color')
 * @returns - associative text color hex value
 *
 * @example
 * getTextColor('colorPrimaryBase');
 */
export const getTextColor = color => {
  if (!color) {
    return [undefined, undefined];
  }
  if (color.toLowerCase().includes('black')) {
    return [undefined, 'var(--color-white-base)'];
  }
  if (color.toLowerCase().includes('white')) {
    return [undefined, 'var(--color-black-base)'];
  }
  const returnColor = convertToCssCustomProperty(color).replace('color', 'color-text');
  return [undefined, returnColor];
};
export default getColor;